// Single source of truth for research reports. Add one `require(...)` line per new
// report JSON. CommonJS so the React app (import) and the Node build scripts
// (sitemap + PNG generation, require) share the exact same list.
const india = require("./india-app-quality-report-2026.json");

const ALL_REPORTS = [india];

function publishedReports() {
  return ALL_REPORTS.filter((r) => r.published).sort(
    (a, b) =>
      new Date(b.dateModified || b.datePublished) -
      new Date(a.dateModified || a.datePublished)
  );
}

function reportBySlug(slug) {
  return ALL_REPORTS.find((r) => r.slug === slug) || null;
}

// INDEXABLE routes for sitemap.xml — only once a report is published.
function researchSitemapRoutes() {
  const pub = publishedReports();
  if (!pub.length) return [];
  return [
    { loc: "/research/", priority: "0.7", changefreq: "weekly" },
    ...pub.map((r) => ({ loc: `/research/${r.slug}`, priority: "0.8", changefreq: "monthly" })),
  ];
}

module.exports = { ALL_REPORTS, publishedReports, reportBySlug, researchSitemapRoutes };
